module.exports = __webpack_public_path__ + "static/img/page top img_semi_mobile.92408913.jpg";